<template>
  <div class="prize-list">
    <button class="prize-btn" type="button" name="button" @click="getPrizeList">我的奖品</button>
    <!-- 礼物列表 -->
    <van-popup v-model="showPrizeList" class="popup prizePopup">
      <div class="popup-wrap">
        <div class="popup-content">
          <div class="popup-title">我的奖品</div>
          <div class="popup-box">
            <table>
              <tr>
                <th>奖品名称</th>
                <th>领取时间</th>
                <th>操作</th>
              </tr>
              <tr
                v-show="$state.prizeList.length>0"
                v-for="(item,index) in $state.prizeList"
                :key="index"
              >
                <td v-if="item.prize.category==='thanks'">谢谢参与</td>
                <td v-else-if="item.prize.category==='money'">{{item.prize.value}}元{{item.prize.name}}</td>
                <td v-else>{{item.prize.name}}</td>
                <td>{{item.created_time}}</td>
                <td v-if="item.prize.category==='link'" @click="handlerlook(item.prize)">点击查看</td>
                <td v-else>已领取</td>
              </tr>
              <tr v-show="$state.prizeList.length===0">
                <td colspan="3">暂无奖品~</td>
              </tr>
            </table>
          </div>
        </div>
        <div @click="showPrizeList=false" class="popup-close"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  getPrizeList
} from '../../mixins/functions'
export default {
  name: 'prize-list',
  data() {
    return {
      showPrizeList:false,
      prizeListLen: 0
    }
  },
  methods: {
    handlerlook(item) {
      if (item.category === 'link') {
        if (item.link.indexOf('alipays://') > -1) {
          ap.pushWindow(item.link)
        } else {
          ap.pushWindow(`alipays://platformapi/startapp?appId=20000021&a=lb&b=c`)
        }
      }
    },
    async getPrizeList() {
      const res = await getPrizeList.call(this)
      if (res.code === 0) {
        this.$state.prizeList= res.data
        this.showPrizeList = true
        this.prizeListLen = this.$state.prizeList.length
      } else {
        this.$toast(res.msg)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.prize-btn {
    position: absolute;
    bottom: -60px;
    left: -20px;
    border: 0;
    height: 40px;
    color: #fff;
    padding: 0 30px 0 10px;
    font-size: 26px;
    display: flex;
    align-items: center;
    border: 2px solid #fe5e5c;
    box-sizing: content-box;
    border-left: 0;
    background: transparent;
    border-top-right-radius: 21px;
    border-bottom-right-radius: 21px;
    &::after {
        content: '';
        display: inline-block;
        position: absolute;
        width: 0;
        height: 0;
        right: 10px;
        top: 15px;
        border-style: solid;
        border-width: 10px 10px 0;
        border-color: #fff transparent transparent;
        transform: rotate(-90deg);
    }
}
.prizePopup {
  font-size: 30px;
  .popup-wrap{
    padding: 50px;
  }
  .popup-title{
    text-align: center;
    margin-bottom: 20px;
    font-size: 36px;
    font-weight: bold;
    color:#fff;
  }
  .popup-content {
    background:  #b71f2a;
    border:4px solid #ea202e;
    border-radius: 20px;
    position: relative;
    border-radius: 25px;
    padding:40px 0;
    margin-bottom: 20px;
    &:after{
      top:auto;
      bottom:-80px;
    }
    .popup-box {
      width: 680px;
      table {
        width: 100%;
        text-align: center;
        font-size: 26px;
        border-spacing: 0;
        th {
          color:#fff;
        }
        td {
          color:#fff;
        }
        td,
        th {
          min-width: 158px;
          height: 80px;
          box-sizing: border-box;
        }
        td:nth-of-type(3) {
          color: #fdb92c;
        }
      }
    }
  }
}
.my-draw {
  position: fixed;
  top: 680px;
  width: 100px;
  right: 15px;
  z-index: 100;
  border-radius: 50px;
}
</style>
